module.exports = {
  label: {
    headerTitle: 'Report',
    company: 'Company',
    selectCompany: 'Select Company',
    site: 'Site',
    selectSite: 'Select Site',
    selectDate: 'Select Date',
    search: 'Search...',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      delete: 'Delete',
      edit: 'Edit'
    },
    buttons: {
      filter: 'Filter',
      export: 'Export To Excel'
    }
  }
}
